import React, { FC } from 'react';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { FUNDS_ADD_MEASUREMENT_DATE } from 'common/constants/funds';
import { AddMeasurementDateButtonProps } from './types';

const AddMeasurementDateButton: FC<AddMeasurementDateButtonProps> = props => {
  const { openMeasurementDateModal } = props;

  return (
    <Button color="primary" endIcon={<AddIcon />} onClick={openMeasurementDateModal} variant="outlined">
      {FUNDS_ADD_MEASUREMENT_DATE}
    </Button>
  );
};

export default AddMeasurementDateButton;
